import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import ImageLoader from '@starbucks-web/pattern-library/lib/components/image-loader';
import Button from '@starbucks-web/pattern-library/lib/components/button';
import { useModalContext } from '@starbucks-web/pattern-library/lib/components/modal-provider';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';
import bagOnTheGo from '@starbucks-web/pattern-library/lib/icons/bag-on-the-go';
import cupOnMat from '@starbucks-web/pattern-library/lib/icons/cup-on-mat';

import { setPostStoreSelectionReturnUrl } from 'ordering/app/state/actions/post-store-selection-return-url';
import { configImagesUrlSelector } from 'shared/app/state/selectors/config';
import { isMobileViewportSelector } from 'shared/app/bundles/viewport';
import OverlayWithCloseMessage from 'shared/app/components/overlay-with-close-message';
import { commonMessages } from 'shared/app/messages/common-words';
import { FullWidthButton } from 'shared/app/components/full-width-button';

import {
  trackOrderTypeModalView,
  trackPickupCtaClickOnModal,
  trackDeliveryCtaClickOnModal,
} from '../../../state/actions/track-event';

import styles from './styles.cssm';
import messages from '../../../messages';

export const ORDER_TYPE_MODAL_ID = 'OrderTypeModalId';

export const OrderTypeModal = () => {
  const dispatch = useDispatch();
  const isMobileViewport = useSelector(isMobileViewportSelector);
  const alignment = isMobileViewport ? 'fullscreen' : 'dialog-lg';
  const { closeModal } = useModalContext();
  const configImagesUrl = useSelector(configImagesUrlSelector);
  const orderTypeImageUrl = `${configImagesUrl}/delivery/order-type.png`;

  useEffect(() => {
    trackOrderTypeModalView();
  }, []);

  const pickupOnClickHandler = () => {
    dispatch(setPostStoreSelectionReturnUrl());
    trackPickupCtaClickOnModal();
    closeModal();
  };

  const deliveryOnClickHandler = () => {
    dispatch(setPostStoreSelectionReturnUrl());
    trackDeliveryCtaClickOnModal();
    closeModal();
  };

  return (
    <OverlayWithCloseMessage
      alignment={alignment}
      childrenContainerClassName={
        isMobileViewport ? '' : `${styles.background}`
      }
      className={isMobileViewport ? `${styles.background}` : ''}
      closeProps={{
        highContrast: true,
      }}
    >
      <ContentColumn size="md">
        <ImageLoader alt="" className="mt4 md-mt7" src={orderTypeImageUrl} />
        <Heading
          className="text-center text-bold my3 md-my4 mx6 color-white text-lg"
          id={ORDER_TYPE_MODAL_ID}
          tagName="h2"
        >
          <FormattedMessage {...messages.orderType} />
        </Heading>
        <div className="mb3">
          <FullWidthButton
            className={`text-sm ${styles.highContrastOutline}`}
            color="white"
            icon={<Icon path={cupOnMat} />}
            onClick={pickupOnClickHandler}
            tagName={Link}
            to="menu/store-locator"
            visualStyle="positive"
          >
            <FormattedMessage {...commonMessages.pickupLabel} />
          </FullWidthButton>
        </div>
        <div className="mb3">
          <FullWidthButton
            className={`text-sm ${styles.highContrastOutline}`}
            color="white"
            icon={<Icon path={bagOnTheGo} />}
            onClick={deliveryOnClickHandler}
            tagName={Link}
            to="menu/store-locator/delivery"
          >
            <FormattedMessage {...commonMessages.deliveryLabel} />
          </FullWidthButton>
        </div>

        <Button
          className={`text-noUnderline my2 mx3 md-mb7 color-white text-semibold ${styles.highContrastOutline}`}
          onClick={() => closeModal()}
          visualStyle="textLink"
        >
          <FormattedMessage {...messages.justBrowsing} />
        </Button>
      </ContentColumn>
    </OverlayWithCloseMessage>
  );
};
